import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SignWithPIN} from '../../states/profile/profile.actions';
import {take, withLatestFrom} from 'rxjs/operators';
import {Select, Store} from '@ngxs/store';
import {Observable} from 'rxjs/internal/Observable';
import {ProfileState} from '../../states/profile/profile.state';
import {fadeInOut} from '../../animations/animations';
import { AuthState } from '../../states/auth/auth.state';
import { UserRolesEnum } from '../../interfaces/UserRolesEnum';

@Component({
  selector: 'app-enter-pin-dialog',
  templateUrl: './enter-pin-dialog.component.html',
  styleUrls: ['./enter-pin-dialog.component.scss'],
  animations: [fadeInOut],
})
export class EnterPinDialogComponent {
  @Input() isWitness: boolean;

  @Input() set show(value: boolean) {
    this.showInner = value;

    if (!value) {
      this.resetPinDialog();
    }
  }

  get show(): boolean {
    return this.showInner;
  }

  @Input() focusPin: boolean;

  @Output() setPinHandler: EventEmitter<{ success, pin, response? }> = new EventEmitter();
  @Output() cancel: EventEmitter<void> = new EventEmitter();
  @Output() handleResetPin: EventEmitter<void> = new EventEmitter();

  isInvalid: boolean;
  isWitnessPinInvalid: boolean;
  isDisabled: boolean;

  showInner: boolean;

  errorPinCountMessage = 'Transaction not recorded. Verify your PIN and record the transaction again.';

  public pinValue: string;

  @Select(ProfileState.success) success$: Observable<boolean>;
  @Select(ProfileState.witnessError) witnessError$: Observable<boolean>;

  constructor(
    private store: Store,
  ) {
  }

  codeComplete(pin: string): void {
    if (pin) {
      this.pinValue = pin;
      this.isDisabled = true;
      this.isInvalid = false;
      this.isWitnessPinInvalid = false;

      this.store.dispatch(new SignWithPIN({pin, isWitness: this.isWitness}))
        .pipe(take(1), withLatestFrom(this.success$, this.witnessError$))
        .subscribe(([_, success, isWitnessSame]) => {
          this.isWitnessPinInvalid = this.isWitness && isWitnessSame && this.amendingWitnessUsersSameAndStaff();
          this.isInvalid = !success || !!this.isWitnessPinInvalid;
          this.isDisabled = false;
          const pinResponse = this.store.selectSnapshot(ProfileState).response;
          this.setPinHandler.emit({success: !this.isInvalid, pin, response: pinResponse});

          if (this.isInvalid) {
            this.pinValue = '';
          }
        });
    }
  }

  private resetPinDialog(): void {
    this.pinValue = '';
    this.isDisabled = false;
    this.isInvalid = false;
    this.isWitnessPinInvalid = false;
  }

  private amendingWitnessUsersSameAndStaff(): boolean {
    const amendingUserId = this.store.selectSnapshot(ProfileState)?.amendingUserId;
    const witnessUserId = this.store.selectSnapshot(ProfileState)?.witnessUserId;
    if (amendingUserId && witnessUserId) {

      if(amendingUserId !== witnessUserId) return false;

      const user = this.store.selectSnapshot(ProfileState)?.teamList?.find(x => x.id === amendingUserId);

      return user?.role === UserRolesEnum.PharmacyStaff;
    }
    return false;
  }
}
